<glxy-badge [color]="color" size="small">{{ status }}</glxy-badge>
